import { Link } from "gatsby";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";

import fallbackIcon from "../../assets/images/fallback_icon.png";
import { arrowRight } from "../../assets/images/icons";
import { ingestData } from "../../bridges/BridgeServices";
import { EVENTS } from "../../utils/constants";
import { createRedirectURL } from "../../utils/helperFunctions";
import "./categoryListItem.scss";
import contentParserOptions from "../../utils/parser";
import { setFaqTitle } from "../../store/slices/common/common.setters";

const CategoryListItem = ({
  allPagesData = {},
  uri = "",
  lastItem = false,
}) => {
  const {
    title = "",
    pageDescription = "",
    thumbnailUrl = "",
    isContactSupportVisible = false,
  } = allPagesData[uri] || {};

  return (
    <>
      <Link
        to={createRedirectURL(uri)}
        className="category-link"
        onClick={() => {
          setFaqTitle({ title }, isContactSupportVisible);
          ingestData({
            name: EVENTS.FAQ_CATEGORY_CLICKED,
            data: {
              faqTitle: title,
            },
          });
        }}
      >
        <div className="category-list-item">
          <div className="category-list-item-icon">
            <img
              src={
                thumbnailUrl === ""
                  ? fallbackIcon
                  : thumbnailUrl
              }
            />
          </div>
          <div className="category-list-item-content">
            <div className="category-list-item-title">
              {title}
            </div>
            <div
              className="category-list-item-excerpt"
              title={pageDescription}
            >
              {parse(pageDescription, contentParserOptions)}
            </div>
          </div>
          <div className="category-list-item-span">
            {parse(arrowRight)}
          </div>
        </div>
      </Link>
      <hr
        className={
          lastItem
            ? "category-list-item-hr-full"
            : "category-list-item-hr-partial"
        }
      />
    </>
  );
};

CategoryListItem.propTypes = {
  allPagesData: PropTypes.object,
  uri: PropTypes.string,
  lastItem: PropTypes.bool,
};

export default CategoryListItem;
